import { EnumerationsLogoutType } from 'client/identity'
import type { AxiosError } from 'axios'
import { useAuthStore } from '~/stores/auth'

export const handleError = (
  error: any | AxiosError<any>,
  shouldRedirect = true,
  authStore = useAuthStore()
) => {
  // only handling 401 errors right now but could be expanded for other status
  if (error?.response?.status === 401 && shouldRedirect) {
    // log out user they are not logged in properly
    // or there was an error trying to access a page they don't have access to
    authStore.logout(EnumerationsLogoutType.Manual)
  }

  // BadRequest (400) and UnprocessableEntity (422)
  // Can happen during normal application operation
  // Broadly speaking, used by BE to indicate input needs update
  if (error?.response?.status && [400, 422].includes(error?.response?.status)) {
    // Don't log error
    return
  }

  console.error(error)
}
